import { render, staticRenderFns } from "./CoronarografiaPtcaEdit.vue?vue&type=template&id=890c1d84&scoped=true"
import script from "./CoronarografiaPtcaEdit.vue?vue&type=script&lang=js"
export * from "./CoronarografiaPtcaEdit.vue?vue&type=script&lang=js"
import style0 from "./CoronarografiaPtcaEdit.vue?vue&type=style&index=0&id=890c1d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890c1d84",
  null
  
)

export default component.exports